import { render, staticRenderFns } from "./ApprovalDesignList.vue?vue&type=template&id=24acde56&"
import script from "./ApprovalDesignList.vue?vue&type=script&lang=js&"
export * from "./ApprovalDesignList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports